import { Mail } from "lucide-react";
import { SocialLink } from "./SocialLink";
import { FooterTicker } from "./FooterTicker";
import { FOOTER_LINKS, SOCIALS } from "../data/portfolioData";

const ICON_CLASS = "w-5 h-5";

export const SiteFooter = ({ onNavigate }) => {
  return (
    <footer
      className="bg-[hsl(var(--card))] border-t border-[hsl(var(--border))] py-16"
      data-testid="footer"
    >
      <div className="mx-auto px-4 sm:px-6 lg:px-10 max-w-7xl">
        <FooterTicker />
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div data-testid="footer-about">
            <h3 className="font-display text-2xl font-bold mb-4 text-[hsl(var(--foreground))]">Ryan M Colon</h3>
            <p className="text-sm text-[hsl(var(--muted-foreground))] mb-4 leading-relaxed">
              Entrepreneur, Affiliate, Digital Creator. Living life unbound and helping others achieve financial freedom.
            </p>
            <a
              href="mailto:mail@ryanmcolon.com"
              className="text-sm text-[hsl(var(--primary))] hover:text-[hsl(var(--primary))]/80 transition-colors inline-flex items-center gap-2 glow"
            >
              <Mail className="w-4 h-4" />
              mail@ryanmcolon.com
            </a>
          </div>

          <div data-testid="footer-links">
            <h3 className="font-display text-xl font-bold mb-4 text-[hsl(var(--foreground))]">Quick Links</h3>
            <div className="space-y-3">
              {FOOTER_LINKS.map((link) => (
                <button
                  key={link.id}
                  onClick={() => onNavigate(link.id)}
                  className="block text-sm text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))] transition-colors"
                  data-testid={`footer-link-${link.id}`}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          <div data-testid="footer-social">
            <h3 className="font-display text-xl font-bold mb-4 text-[hsl(var(--foreground))]">Connect</h3>
            <div className="flex flex-wrap gap-3">
              {SOCIALS.map((social) => (
                <SocialLink
                  key={social.testId}
                  href={social.href}
                  label={social.label}
                  testId={social.testId}
                  brand={social.brand}
                  isMail={social.isMail}
                >
                  <social.Icon className={ICON_CLASS} />
                </SocialLink>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-[hsl(var(--border))] pt-8 text-center">
          <p className="font-mono text-sm text-[hsl(var(--muted-foreground))]" data-testid="footer-copyright">
            © 2025 Ryan M Colon. Live Life Unbound
          </p>
        </div>
      </div>
    </footer>
  );
};
